import type { SearchAlertsSearchModalXinglet } from '@xing-com/crate-jobs-xinglets';

import { DesktopModal, MobileBottomSheet } from './components';

export default class Modal implements SearchAlertsSearchModalXinglet {
  public getComponent(): React.FC {
    return () => (
      <>
        <DesktopModal />
        <MobileBottomSheet />
      </>
    );
  }
}
